var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11803",
    "data-name": "Group 11803",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "auto",
    height: "auto",
    viewBox: "0 0 35.333 31.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1968",
    "data-name": "Rectangle 1968",
    width: 35.333,
    height: 31.943,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11802",
    "data-name": "Group 11802",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M14.588,29.1.306,53.835a2.256,2.256,0,0,0,1.953,3.384H30.824a2.256,2.256,0,0,0,1.954-3.384L18.5,29.1a2.256,2.256,0,0,0-3.907,0",
    transform: "translate(0 -25.275)",
    fill: "#ff005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M32.255,31.465H3.69A3.364,3.364,0,0,1,.777,26.42L15.059,1.682h0a3.364,3.364,0,0,1,5.826,0L35.167,26.42a3.363,3.363,0,0,1-2.913,5.045M16.978,2.789,2.7,27.527a1.148,1.148,0,0,0,.994,1.722H32.255a1.148,1.148,0,0,0,.994-1.722L18.966,2.789a1.148,1.148,0,0,0-1.988,0",
    transform: "translate(-0.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M168.458,105.678c-2.531-.19-1.808,10.432,0,10.559s2.531-10.369,0-10.559",
    transform: "translate(-150.751 -95.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M167.866,233.152a1.874,1.874,0,1,1-1.874-1.874,1.874,1.874,0,0,1,1.874,1.874",
    transform: "translate(-148.311 -209.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a1d9321a7f1f8f8fc08f9854959db80b.svg";
export { ForwardRef as ReactComponent };